import { ASSET_STATUS_LABELS, type AssetStatus } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function AssetStatusBadge({ status }: { status: AssetStatus }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        status === 'IN_STOCK' && 'border-zinc-300 text-zinc-700',
        status === 'IN_SERVICE' && 'border-emerald-300 bg-emerald-50 text-emerald-800',
        status === 'DEFECTIVE' && 'border-red-300 bg-red-50 text-red-800',
        status === 'DECOMMISSIONED' && 'border-zinc-300 bg-zinc-100 text-zinc-700',
      )}
    >
      {ASSET_STATUS_LABELS[status]}
    </Badge>
  );
}

export function DateExpiryBadge({ expired, label }: { expired: boolean; label: string }) {
  return (
    <span className={cn(expired && 'text-destructive')}>
      {label}
      {expired ? ' (abgelaufen)' : ''}
    </span>
  );
}
